import React, { useState } from "react";
import { Card, Table, TableBody, TableHead, TableHeader, TableRow } from "@libs/zapi-ui/shadcn";
import { AiLogsByRequestId } from "@/zapi-admin/pages/AiLogsPage/model/types";
import { PaginationControls } from "./PaginationControls";
import { AILogsTableRow } from "@/zapi-admin/pages/AiLogsPage/ui/AiLogsTableRow";

type TAILogsTableProps = {
  logs: AiLogsByRequestId;
  total?: number;
  page?: number;
  pageSize?: number;
  onDetailClick: (logId: number) => void;
  setPage?: (page: number) => void;
};

export function AILogsTable({ logs, total = 0, page = 0, setPage, pageSize = 0, onDetailClick }: TAILogsTableProps) {
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const handleExpand = (requestId: string) => {
    setExpandedRow(expandedRow === requestId ? null : requestId);
  };

  return (
    <Card className="py-0 rounded-[10px] border-zinc-150 border gap-0" data-testid="ai-logs-table-card">
      <Table className={"p-[12px] text-zinc-500 text-[10px]"} data-testid="ai-logs-table">
        <TableHeader className={"p-[12px] text-zinc-500 text-[10px]"}>
          <TableRow>
            <TableHead className="min-w-[30px] text-zinc-600 text-[14px] capitalize">Task ID</TableHead>
            <TableHead className="min-w-[30px] text-zinc-600 text-[14px] capitalize">Cost</TableHead>
            <TableHead className="min-w-[334px] text-zinc-600 text-[14px] capitalize">Task</TableHead>
            <TableHead className="min-w-[200px] text-zinc-600 text-[14px] capitalize">Project</TableHead>
            <TableHead className="min-w-[200px] text-zinc-600 text-[14px] capitalize">Chapter ID</TableHead>
            <TableHead className="min-w-[120px] text-zinc-600 text-[14px] capitalize">User</TableHead>
            <TableHead className="min-w-[104px] text-zinc-600 text-[14px] capitalize">Created at</TableHead>
            <TableHead className="min-w-[84px] text-zinc-600 text-[14px] capitalize">Execution Time</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {logs.map((logGroup) => (
            <AILogsTableRow
              key={logGroup.requestId}
              logGroup={logGroup}
              onDetailClick={onDetailClick}
              expanded={expandedRow === logGroup.requestId}
              setExpanded={(v) => (v ? handleExpand(logGroup.requestId) : setExpandedRow(null))}
            />
          ))}
        </TableBody>
      </Table>
      <PaginationControls page={page} total={total} pageSize={pageSize} setPage={setPage} />
    </Card>
  );
}
